import React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { DATE_PRESETS } from './constants';

const CommissionsFilters = ({
  datePreset,
  setDatePreset,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  searchTerm,
  setSearchTerm
}) => {
  return (
    <Card className="border-slate-200">
      <CardContent className="pt-6">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Date preset */}
          <div className="w-full md:w-48">
            <Label className="text-sm text-slate-600">Período</Label>
            <Select value={datePreset} onValueChange={setDatePreset}>
              <SelectTrigger className="mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {DATE_PRESETS.map(p => (
                  <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {/* Custom dates */}
          <div className="w-full md:w-40">
            <Label className="text-sm text-slate-600">Fecha Inicio</Label>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                setDatePreset('custom');
              }}
              className="mt-1"
            />
          </div>
          <div className="w-full md:w-40">
            <Label className="text-sm text-slate-600">Fecha Fin</Label>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setDatePreset('custom');
              }}
              className="mt-1"
            />
          </div>

          {/* Search */}
          <div className="flex-1">
            <Label className="text-sm text-slate-600">Buscar médico</Label>
            <div className="relative mt-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                placeholder="Nombre del médico..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10"
                data-testid="search-doctor"
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CommissionsFilters;
